import {
  createSlice,
  createAsyncThunk,
  createEntityAdapter,
} from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../app/constants";

export const topProduct = createAsyncThunk(
  "topProduct/topProduct",
  async ({ uid }) => {
    /// ******** API Top Product ********
    const response = await axios.post(`${baseUrl}top_product`, {
      uid: uid,
    });
    return response.data.response;
  }
);

const changePasswordEntity = createEntityAdapter({
  selectId: (topProduct) => topProduct.id,
});

const changePasswordSlice = createSlice({
  name: "topProduct",
  initialState: changePasswordEntity.getInitialState(),
  extraReducers: {
    [topProduct.pending]: (state) => {
      // console.log('pending')
    },
    [topProduct.fulfilled]: (state, action) => {
      changePasswordEntity.setAll(state, action.payload);
    },
    [topProduct.rejected]: (state) => {
      // console.log("rejected");
    },
  },
});

export const changePasswordSelector = changePasswordEntity.getSelectors(
  (state) => state.topProduct
);
export default changePasswordSlice.reducer;
